import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ICustoEquipePlanejamentoModel } from 'src/app/models/custo-equipe-planejamento.model';
import { CustoEquipePlanejamentoService } from 'src/app/services/custo-equipe-planejamento.service';
import Swal from 'sweetalert2';
import { BaseFormComponent } from '../../base-form/base-form.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { CustosEquipeFormModalComponent } from '../custos-equipe-form-modal/custos-equipe-form-modal.component';

@Component({
  selector: 'app-custos-equipe-list',
  templateUrl: './custos-equipe-list.component.html'
})
export class CustosEquipeListComponent extends BaseFormComponent implements OnInit {
  @Input() visualizar = false;
  @Input() secaoId = 1;
  @Output() subtotalChange = new EventEmitter<number>();

  modelCustoEquipePlanejamento: ICustoEquipePlanejamentoModel = {} as ICustoEquipePlanejamentoModel;

  custoEquipeDataSource = new MatTableDataSource<ICustoEquipePlanejamentoModel>();
  custoEquipeSemDados = false;
  public tipoTrabalho: string;

  displayedColumns: string[] = [
    'nomeAgente',
    'dataInicio',
    'dataFim',
    'diasCorridos',
    'salario',
    'custoFinal',
    'actions'
  ];

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private custoEquipeService: CustoEquipePlanejamentoService,
    public matDialog: MatDialog,
  ) {
    super(route, toastr, router, localeService, matDialog);

    if (this.router.url.includes("planejamento")) {
      this.tipoTrabalho = 'planejamento';
    }
    if (this.router.url.includes("osa")) {
      this.tipoTrabalho = 'osa';
    }
  }

  ngOnInit(): void {
    this.carregarCustos();
  }

  ngOnChanges(): void {
    const total = this.calcularSubtotal();
    this.subtotalChange.emit(total);
  }

  public async carregarCustos() {
    try {
      this.custoEquipeService.obterPorPlanejamento(this.id, this.tipoTrabalho, this.secaoId).then((res) => {
        if (res.sucesso) {
          this.custoEquipeDataSource = new MatTableDataSource<ICustoEquipePlanejamentoModel>
            (
              res.dados
            );
          this.custoEquipeDataSource._updateChangeSubscription();
          this.modelCustoEquipePlanejamento = {} as ICustoEquipePlanejamentoModel;
          this.custoEquipeSemDados = res.dados.length != 0 ? false : true;
        } else {
          this.submit = false;
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
          this.router.navigate(['/planejamento']);
          return;
        }
      });
    } catch (err) {
      this.submit = false;
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        text: err.mensagem?.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
      this.router.navigate(['/planejamento']);
    }
  }

  incluir(): void {
    try {
      const dados = {
        planejamentoId: this.id,
        osaId: this.id,
        secaoId: this.secaoId,
        agentePublicoId: null,
        dataInicio: null,
        dataFim: null
      } as ICustoEquipePlanejamentoModel

      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-component';
      dialogConfig.width = '650px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        ...dados,
        registrosExistentes: this.custoEquipeDataSource.data
      };
      const modal = this.matDialog.open(
        CustosEquipeFormModalComponent,
        dialogConfig
      );

      modal.afterClosed().subscribe(res => {
        if (res === true) {
          this.carregarCustos();
        }
      });
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        text: err.mensagem?.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  editar(item: ICustoEquipePlanejamentoModel): void {
    try {
      const dados = {
        ...item,
        dataInicio: item.dataInicio ? new Date(item.dataInicio) : null,
        dataFim: item.dataFim ? new Date(item.dataFim) : null,
      };

      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-component';
      dialogConfig.width = '650px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = dialogConfig.data = {
        ...dados,
        registrosExistentes: this.custoEquipeDataSource.data
      };

      const modal = this.matDialog.open(
        CustosEquipeFormModalComponent,
        dialogConfig
      );

      modal.afterClosed().subscribe(res => {
        if (res === true) {
          this.carregarCustos(); // atualiza a lista após edição
        }
      });
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        text: err.mensagem?.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  excluir(id: number): void {
    Swal.fire({
      title: 'Confirma a exclusão?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        this.custoEquipeService.excluir(id).subscribe(res => {
          if (res.sucesso) {
            this.carregarCustos();
          }
        });
      }
    });
  }

  calcularSubtotal(): number {
    const total = this.custoEquipeDataSource.data
      ?.reduce((total, item) => total + (item.custoFinal || 0), 0) || 0;

    this.subtotalChange.emit(total);

    return total;
  }
}
